export default __webpack_public_path__ + "images/logoWwd.e7d07948de5966d990dbe834e4705c81.svg"